import React from 'react';
import { useUserPreferencesStore } from 'stores/userPreferencesStore';
import Toast from 'components/Toast';
import styles from './Settings.module.scss';

function Settings() {
  const betaEnabled = useUserPreferencesStore((s) => s.betaEnabled);
  const isLoading = useUserPreferencesStore((s) => s.isLoading);
  const setBetaEnabled = useUserPreferencesStore((s) => s.setBetaEnabled);
  const [toast, setToast] = React.useState<{
    message: string;
    type: 'success' | 'error';
  } | null>(null);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>App Settings</h1>
      <p className={styles.subtitle}>
        These preferences are saved per user account on this device.
      </p>

      <section className={styles.card}>
        <div>
          <h2 className={styles.settingTitle}>Enable Beta Version</h2>
          <p className={styles.settingDescription}>
            Show beta-only modules and advanced pages.
          </p>
        </div>
        <label className={styles.toggle}>
          <input
            type="checkbox"
            checked={betaEnabled}
            disabled={isLoading}
            onChange={(e) => {
              void setBetaEnabled(e.target.checked)
                .then(() =>
                  setToast({ message: 'Settings saved', type: 'success' }),
                )
                .catch((error: unknown) =>
                  setToast({
                    message:
                      error instanceof Error
                        ? error.message
                        : 'Failed to save settings',
                    type: 'error',
                  }),
                );
            }}
          />
          <span>
            {isLoading ? 'Loading...' : betaEnabled ? 'Enabled' : 'Disabled'}
          </span>
        </label>
      </section>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}

export default Settings;
